/*
 * SIJL - foto's bij de Koffietrip-pagina's in het zoekpaneel.
 *
 * Het zoekpaneel wordt in sijl-custom.js opgebouwd uit wat Shopify terugstuurt
 * op een zoekopdracht. Bij een product of een blogartikel zit daar een foto
 * bij; bij een pagina niet, want een Shopify-pagina heeft geen afbeeldingsveld.
 * Vandaar dat een stadspagina daar met een leeg grijs vlak stond.
 *
 * Dit bestand vult dat vlak alsnog. De foto's komen uit het lijstje dat
 * snippets/sijl-zoek-data.liquid op de pagina zet; daar staat per stad de
 * eerste bar met een foto. Heeft een stad er nog geen, dan zetten we er een
 * speldje in plaats van niets - dat leest als "hier hoort nog iets", en niet
 * als een kapot plaatje.
 *
 * Apart bestand, en niet in sijl-custom.js: dat is drieënvijftig kilobyte en
 * kan alleen in zijn geheel worden teruggestuurd. Dit hoort bij de Koffietrip
 * en staat dus op zichzelf.
 *
 * Wordt geladen uit layout/theme.liquid.
 */

(function () {
  'use strict';

  var BRON = 'sijl-stadfotos';
  var PAD = '/pages/koffietrip-';

  var bron = document.getElementById(BRON);
  if (!bron) return;

  var kaart;
  try {
    kaart = JSON.parse(bron.textContent);
  } catch (fout) {
    return;
  }
  if (!kaart) return;

  /* Het speldje voor een stad die nog geen foto heeft. Bewust klein en in de
     huiskleur - het moet een plek markeren, geen aandacht trekken. */
  function speldje() {
    var wrap = document.createElement('span');
    wrap.className = 'sijl-zoek__speld';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#cf6114;';
    wrap.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"' +
      ' stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"></path>' +
      '<circle cx="12" cy="10" r="2.4"></circle></svg>';
    return wrap;
  }

  function handleVan(link) {
    var adres = link.getAttribute('href') || '';
    if (adres.indexOf(PAD) === -1) return '';
    var kaal = adres.split('?')[0].split('#')[0];
    var stukken = kaal.split('/');
    return stukken[stukken.length - 1] || '';
  }

  function vul(wortel) {
    if (!wortel || !wortel.querySelectorAll) return;
    var links = wortel.querySelectorAll('a[href*="' + PAD + '"]');
    for (var i = 0; i < links.length; i++) {
      var vak = links[i].querySelector('.sijl-zoek__foto');
      if (!vak || vak.firstElementChild) continue;

      var adres = kaart[handleVan(links[i])];
      if (adres) {
        var plaat = new Image();
        plaat.src = adres;
        plaat.alt = '';
        plaat.loading = 'lazy';
        vak.appendChild(plaat);
      } else {
        vak.appendChild(speldje());
      }
    }
  }

  /* Het paneel wordt pas gevuld als je begint te typen, en daarna bij elke
     toetsaanslag opnieuw. Dus kijken we mee in plaats van één keer te kijken.
     Meerdere panelen tegelijk kan: er is er een voor mobiel en een voor het
     grote scherm. */
  function kijkMee() {
    var panelen = document.querySelectorAll('.sijl-zoek');
    if (panelen.length === 0) return false;

    var wacht = null;
    var bewaker = new MutationObserver(function () {
      if (wacht) return;
      wacht = window.requestAnimationFrame(function () {
        wacht = null;
        for (var i = 0; i < panelen.length; i++) vul(panelen[i]);
      });
    });

    for (var i = 0; i < panelen.length; i++) {
      bewaker.observe(panelen[i], { childList: true, subtree: true });
      vul(panelen[i]);
    }
    return true;
  }

  /* De header komt soms later binnen dan dit script. Een paar keer proberen is
     genoeg; blijft het paneel weg, dan is er gewoon niets te vullen. */
  function start() {
    if (kijkMee()) return;
    var pogingen = 0;
    var tik = window.setInterval(function () {
      pogingen = pogingen + 1;
      if (kijkMee() || pogingen > 20) window.clearInterval(tik);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();